import React from "react";
import styles from "./eventHistoryFooter.module.css";
import { AVAILABLE_EVENT_TYPES } from "../../eventHistory.constants";

interface EventHistoryFooterProps {
    totalEvents: number;
}

export const EventHistoryFooter = ({ totalEvents }: EventHistoryFooterProps) => {
    return (
        <div className={styles.footerContainer}>
            <div className={styles.aliases}>
                {AVAILABLE_EVENT_TYPES.map((alias) => (
                    <div className={styles.aliasContainer} key={alias.text}>
                        <span className={styles.colorIndicator} style={{ backgroundColor: alias.color.primary }}></span>
                        <span className={styles.aliasText}>{alias.text}</span>
                    </div>
                ))}
            </div>

            <span className={styles.totalEventText}>Total Events: {totalEvents}</span>
        </div>
    )
}
